import reducer from './reducers';

export { default as createResourceSelectors } from './selectors';
export { default as createResourceOperations } from './operations';
export { default as createResourceTypes } from './types';

export default reducer;
